module.exports = __webpack_public_path__ + "static/media/cricket.f4bba73f.wav";